<div class="references-panel">
  <div class="panel-title">
    <div>{{ 'references.title' | translate }}</div>
    <div>
      @if (customActionsTemplate) {
        <ng-container [ngTemplateOutlet]="customActionsTemplate"></ng-container>
      }
    </div>
  </div>
  @if (ready() === undefined || ready()) {
    @if (!loading) {
      @if (_references) {
        @if (_references.length) {
          <div class="references-list">
            @for (reference of _references; track reference.id) {
              <div (click)="onSelect(reference)" class="reference-item ref-id-{{reference.id}} ref-background">
                <div class="reference-header">
                  <div class="text-truncate ref-color" [ngbTooltip]="reference.name" overflowTooltip
                       tooltipClass="simple-tooltip" placement="bottom" [openDelay]="500">
                    {{ reference.name }}
                  </div>
                  @if (reference.sourceUrl) {
                    <a [href]="reference.sourceUrl" rel="noopener noreferrer" target="_blank">
                      <ex-badge icon="globe" text="" borderColor="var(--basic-300)" color="var(--basic-600)"
                                backgroundColor="var(--basic-100)"
                                [ngbTooltip]="'references.goto-source' | translate" tooltipClass="simple-tooltip fit"
                                placement="bottom" [openDelay]="500" />
                    </a>
                  }
                  @if (selectable()) {
                    <div class="reference-radio">
                      @if (selected === reference) {
                        <i class="ph-fill ph-check-circle color-primary-500"></i>
                      } @else {
                        <i class="ph ph-circle color-basic-800"></i>
                      }
                    </div>
                  }
                </div>
                <div class="reference-card-body">
                  <div class="reference-positions color-basic-800">
                    @for (position of reference.relevantPositions; track position) {
                      <div class="d-flex flex-wrap">
                        <div class="reference-position text-limited-2-lines"
                             [ngbTooltip]="position.role" tooltipClass="simple-tooltip max-s text-left"
                             container="body" overflowTooltip placement="bottom auto" [openDelay]="500">
                          @if (position.isOld) {
                            <span class="fst-italic color-basic-600 text-truncate">{{ 'content.old' | translate }} </span>
                          }
                          <span class="me-1" [ngClass]="{'color-basic-600 fst-italic': position.isOld}">{{ position.role }}</span>
                        </div>
                        <span class="position-territory color-basic-600">({{ position.territory.name }})</span>
                      </div>
                    }
                  </div>
                  @if (reference.explainUrl) {
                    <a [href]="reference.explainUrl" target="_blank" class="mt-2 d-flex text-decoration-none">
                      <ex-button [type]="(hoveredReferenceId$ | async) === reference.id ? 'brand' : 'secondary'"
                                 [variant]="(hoveredReferenceId$ | async) === reference.id ? 'tonal' : 'raised'" size="small"
                                 innerFill class="impacter-link-button" icon="caret-right" iconPosition="right">
                        {{ 'references.goto-explain-url' | translate }}
                        {{
                          reference.articleCount ?
                            '(' + (('references.x-article' + (reference.articleCount > 1 ? 's' : '')) | translate: {count: reference.articleCount}) + ')' :
                            ''
                        }}
                      </ex-button>
                    </a>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          @if (emptyTemplate) {
            <ng-container [ngTemplateOutlet]="emptyTemplate"></ng-container>
          }
        }
      } @else if (_references === null) {
        @if (errorTemplate) {
          <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
        }
      } @else {
        @if (placeholderTemplate) {
          <ng-container [ngTemplateOutlet]="placeholderTemplate"></ng-container>
        }
      }
    } @else {
      @if (loadingTemplate) {
        <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
      } @else {
        <app-simple-loader loaderText="" />
      }
    }
    @if (selectable()) {
      <div class="generate-email-container">
        <ex-button type="primary" variant="raised" size="small" (click)="generateBusinessEmail()"
                   [disabled]="generating">
          <div class="text-truncate generate-button-content">
            <mat-icon svgIcon="sparks-filled"></mat-icon>
            <span>
              @if (selected) {
                {{ 'references.generate-business-email-for' | translate: {name: selected.name} }}
              } @else {
                {{ 'references.generate-business-email' | translate }}
              }
            </span>
          </div>
        </ex-button>
      </div>
    }
  } @else {
    <div class="loading">
      <mat-icon svgIcon="loader"></mat-icon>
      <div>{{ 'loader' | translate }}</div>
    </div>
  }
</div>
<div [innerHTML]="referencesStyle"></div>
